import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import UpdatesList from "./UpdatesList";
import PoliciesList from "./PoliciesList";
import BlogList from "./BlogList";
import UpdateDetails from "./UpdateDetails";
import PolicyDetails from "./PolicyDetails";
import BlogDetails from "./BlogDetails";
import { ContentModalProvider } from "./components/ContentModal";
import { DNewsAlertHost } from "./utils/dNews_Alert";

/**
 * Inside D is a PUBLIC website that also serves logged-in employees.
 *
 * Every route here is public. There is no auth guard and no redirect-to-login:
 * landing on "/" shows the home page to everyone. Logging in is OPTIONAL — it unlocks
 * employee-scoped content in place; it does not open a separate area.
 *
 * WHAT a person can see is decided on the server, per row, by the audience filter.
 * The client never makes that decision.
 */
function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ContentModalProvider>
    {/* Mounted once near the root so sign-in toasts survive the navigation away from
        /login and render on any page. */}
    <DNewsAlertHost />
    <Routes>
      <Route path="/" element={<Home />} />
      {/* "/home" was the old authenticated landing page; keep the URL working. */}
      <Route path="/home" element={<Navigate to="/" replace />} />

      <Route path="/login" element={<Login />} />

      {/* Teaser → full page, for all three content types. */}
      <Route path="/updates" element={<UpdatesList />} />
      <Route path="/update/:id" element={<UpdateDetails />} />

      <Route path="/policies" element={<PoliciesList />} />
      <Route path="/policy/:id" element={<PolicyDetails />} />

      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogDetails />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </ContentModalProvider>
  );
}

export default App;
